import { observer } from 'mobx-react-lite'
import styles from './ConfirmEmailView.module.css'
import logoUrl from '@/assets/misc/img_taxfyle-symbol.svg'
import { StyledLink } from '@/components/Link'
import { useActivation, useScopedViewModel } from '@/hooks/view-model-hooks'
import { ConfirmEmailViewModel } from '@/features/email-confirmation/ConfirmEmailView/ConfirmEmailViewModel'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useObservable } from '@/hooks/rx-hooks'
import { useSearchParams } from 'react-router-dom'
import { links } from '@/utils/link'

/**
 * The email confirmation page. This page blocks the sign-in flow until the user
 * verifies their email.
 */
export default observer(function EmailConfirmationView() {
  const vm = useScopedViewModel(
    ({ shell }) => new ConfirmEmailViewModel(shell.newSnackbar),
  )

  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useObservable(vm.navigateToEmailConfirmed$, () =>
    navigate(links.emailConfirmed(), { replace: true }),
  )

  const token = searchParams.get('session_token') ?? ''
  useActivation(
    vm,
    useCallback((v) => v.activate(token), [token]),
  )

  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <img className={styles.logo} src={logoUrl} alt="Taxfyle logo" />
        <h1 className={styles.title}>
          {!vm.pageExpired ? (
            <>Check your inbox and verify your email</>
          ) : (
            <>This page has expired</>
          )}
        </h1>
        <p className="text-body-md-light">
          {!vm.pageExpired ? (
            <>
              {' '}
              We've sent a confirmation email link to{' '}
              <b className="text-headline-md">
                {vm.email ?? 'EMAIL_NOT_SPECIFIED'}
              </b>
              .
            </>
          ) : (
            <>Please log in again.</>
          )}
        </p>
        {!vm.pageExpired && (
          <div className={styles.help}>
            <div className="text-headline-sm">Didn't receive the email?</div>
            <p className={styles.helpText}>
              Check your spam folder or{' '}
              <span className="block">
                <StyledLink onPress={vm.resendVerificationEmail}>
                  send the email again
                </StyledLink>
                .
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  )
})
